import { gql } from '@apollo/client';

export const GET_PLATFORM_SITE_MARKERS = gql`
  query PlatformSiteMarkers {
    platformSiteMarkers
  }
`;

export const UPDATE_PLATFORM_SITE_MARKERS = gql`
  mutation UpdatePlatformSiteMarkers($input: UpdatePlatformSiteMarkersInput!) {
    updatePlatformSiteMarkers(input: $input)
  }
`;
